module.exports = __webpack_public_path__ + "static/media/20190922_1323411.9cd47ea0.jpg";